import {action, makeObservable, observable, runInAction} from 'mobx';
import {ApiRepository, ValidationError} from '../base/api-repository';
import {UserStore} from '../user/user-store';
import * as Sentry from '@sentry/react';
import {LabelStore} from '../base/label-store';

export class CompanyDeleteStore {
    @observable
    state: 'error' | 'deleted' | undefined;
    @observable
    errorReason: 'invalid-token' | 'generic' = 'generic';

    constructor(private api: ApiRepository, private userStore: UserStore, public labelStore: LabelStore) {
        makeObservable(this);
    }

    @action
    async onEnter(): Promise<void> {
        try {
            await this.api.post(`/company/employee/${this.userStore.payload?.employeeId}/delete-company`);
            runInAction(() => {
                this.state = 'deleted';
            });
        } catch (e: unknown) {
            runInAction(() => {
                if ((e as ValidationError).errorMessageCode === 'invalid-token') {
                    this.state = 'error';
                    this.errorReason = 'invalid-token';
                    Sentry.captureException(e);
                } else {
                    this.state = 'error';
                    this.errorReason = 'generic';
                    Sentry.captureException(e);
                }
            });
        }
    }
}
